import { HugeiconsIcon } from "@hugeicons/react";
import { DashboardSquareAddIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Link } from "react-router-dom";
import { cx } from "shared/utils";
import { formatCalendar } from "../helpers/format-calendar";
import { useMarkNotificationAsRead } from "../helpers/call-notification";
import { Notification } from "../types";

// Fallback for `url: null`; keep in sync with the backend Notification#url.
const productRequestUrl = (metadata: Notification["metadata"]) =>
  metadata.product_key
    ? `/products?enable=${encodeURIComponent(metadata.product_key)}`
    : "/products";

const fallbackTitle = (metadata: Notification["metadata"]) =>
  metadata.product_name
    ? `${metadata.requested_by_name || "Someone"} asked to add ${metadata.product_name}`
    : "A product was requested";

// PLT-725: a property manager asked for a Boom product. Opens the products
// page with that product's Enable modal.
export const ProductRequestedNotificationCard = ({
  item
}: {
  item: Notification;
}) => {
  const { id, read_at, url, metadata, created_at } = item;
  const markAsRead = useMarkNotificationAsRead();

  return (
    <Link
      to={url || productRequestUrl(metadata)}
      onClick={() => {
        if (!read_at) markAsRead([id]);
      }}
      className="flex flex-col gap-3 bg-white p-6 hover:bg-alpha-40"
    >
      <div className="flex items-center justify-between gap-4">
        <p className="flex min-w-0 items-center gap-2 text-sm font-medium text-content-300">
          <HugeiconsIcon
            icon={DashboardSquareAddIcon}
            size={16}
            className="shrink-0 text-primary-500"
            aria-hidden
          />
          <span className="truncate">Products</span>
        </p>
        <p className="shrink-0 text-sm font-medium text-content-300">
          {formatCalendar(created_at)}
        </p>
      </div>

      <div className="flex min-w-0 items-center gap-4">
        <span
          className={cx(
            "size-3 shrink-0 rounded-full",
            read_at ? "bg-alpha-40" : "bg-primary-500"
          )}
        />
        <div className="min-w-0">
          <p className="break-words text-base font-bold text-content-1000">
            {metadata.title || fallbackTitle(metadata)}
          </p>
          {metadata.body ? (
            <p className="break-words text-base font-medium text-content-400">
              {metadata.body}
            </p>
          ) : null}
        </div>
      </div>
    </Link>
  );
};
